// swiftcode接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default axios => ({
  // 查询国家
  getcountry: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/swiftcode/index/init-v1`, params),
  // 查询城市
  getcity: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/swiftcode/index/city-v1`, params),
  // 查询银行
  getbank: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/swiftcode/index/bank-v1`, params),
  // 查询结果
  getswiftcode: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/swiftcode/index/complete-v1`, params)
})
